module.exports = __webpack_public_path__ + "static/media/tra_all_sto.8180f418.png";